export default function () {
    function formatISODateToGerman(dateString: string): string {
        const [year, month, day] = dateString.split("-");

        return `${day}.${month}.${year}`;
    }

    function pushIfNotIncludes(array, element) {
        if (!array.includes(element)) {
            array.push(element);
        }
    }

    // helper to merge menu quantities per size for totals objects
    function accumulateMenus(menusObject) {
        return menusObject.reduce((acc, menu) => {
            for (const [menuName, sizes] of Object.entries(menu || {})) {
                if (!acc[menuName]) {
                    acc[menuName] = {};
                }
                for (const [size, config] of Object.entries(sizes)) {
                    if (!acc[menuName][size]) {
                        acc[menuName][size] = {
                            ...config,
                            ids: [...config.ids],
                            orders: [...config.orders],
                        };
                    } else {
                        acc[menuName][size].ids = [
                            ...new Set([
                                ...acc[menuName][size].ids,
                                ...config.ids,
                            ]),
                        ];
                        acc[menuName][size].orders = [
                            ...new Set([
                                ...acc[menuName][size].orders,
                                ...config.orders,
                            ]),
                        ];
                        acc[menuName][size].quantity += config.quantity;
                    }
                }
            }
            return acc;
        }, {});
    }

    // helper to get date of start and end of week
    function getWeekDates(kw) {
        const [year, week] = kw.split("-");
        const formatDate = (date) => date.toLocaleDateString("sv");

        // ISO week date weeks start on Monday, so correct the date to the nearest Monday
        const simple = new Date(year, 0, 1 + (week - 1) * 7);
        const dayOfWeek = simple.getDay();
        const ISOweekStart = simple;
        if (dayOfWeek <= 4) {
            ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
        } else {
            ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
        }

        const monday = new Date(ISOweekStart);
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        return {
            startDate: formatDate(monday),
            endDate: formatDate(sunday),
        };
    }

    // helper to get week number according to ISO Week
    function getISOWeek(date) {
        const tempDate = new Date(date.getTime());
        tempDate.setHours(0, 0, 0, 0);
        tempDate.setDate(
            tempDate.getDate() + 3 - ((tempDate.getDay() + 6) % 7),
        );
        const week1 = new Date(tempDate.getFullYear(), 0, 4);
        return (
            1 +
            Math.round(
                ((tempDate.getTime() - week1.getTime()) / 86400000 -
                    3 +
                    ((week1.getDay() + 6) % 7)) /
                    7,
            )
        );
    }

    // helper to get date of start and end of month
    function getMonthDates(yearMonth) {
        const [year, month] = yearMonth.split("-");
        const formatDate = (date) => date.toLocaleDateString("sv");

        const first = new Date(year, month - 1, 1);
        const last = new Date(year, month, 0);

        return {
            startDate: formatDate(first),
            endDate: formatDate(last),
        };
    }

    function normalizeAddressString(address: string): string {
        if (!address) return "";
        return address
            .toLowerCase()
            .replace(/<br\s*\/?>/gi, " ")
            .replace(/,/g, " ")
            .replace(/\s\s+/g, " ")
            .replace(/strasse/g, "str.")
            .replace(/straße/g, "str.")
            .trim();
    }

    return {
        formatISODateToGerman,
        pushIfNotIncludes,
        accumulateMenus,
        getWeekDates,
        getISOWeek,
        getMonthDates,
        normalizeAddressString,
    };
}
